import { FormGroup, TextArea } from '@agro-club/agroclub-shared'
import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { refetchFunc } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import {
  SharedModalContent,
  SharedModalFooter,
  SharedModalInputs,
  SharedModalTitle,
} from 'views/components/SharedModal'
import ASharedModal from 'views/components/SharedModal/ASharedModal'

type Props = {
  sampleId: number
  refetch: refetchFunc
  onClose: () => void
}

export const ConfirmCancel: FC<Props> = ({ sampleId, refetch, onClose }) => {
  const { t } = useTranslation('samples')
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik({
    initialValues: {
      cancel_comment: '',
    },

    onSubmit: formHandler(
      () => {
        return apiClient.put(endpoints.cancelSample(sampleId.toString()), formik.values)
      },
      {
        onSuccess: () => {
          refetch()
          onClose()
        },
        onError: (error) => {
          formik.setErrors(error.errors)
        },
      },
    ),
  })

  return (
    <ASharedModal onClose={onClose} size="small" id="archive_modal">
      <SharedModalTitle>{t('cancelSample')}</SharedModalTitle>
      <SharedModalContent>
        <SharedModalInputs>
          <FormGroup error={formik.errors.cancel_comment}>
            <TextArea
              className="comment-area"
              {...formik.getFieldProps('cancel_comment')}
              height={82}
              placeholder={t('cancelReasonPlaceholder')}
            />
          </FormGroup>
        </SharedModalInputs>
      </SharedModalContent>
      <SharedModalFooter>
        <AButton progress={formProgress} onClick={() => formik.submitForm()} color="primary" size="big" id="save">
          {t('cancelSample')}
        </AButton>

        <AButton id="close" color="secondary" size="big" onClick={onClose}>
          {t('common:canceling')}
        </AButton>
      </SharedModalFooter>
    </ASharedModal>
  )
}
